import { useState } from "react";
import { Plus } from "lucide-react";

export default function AddGoalForm({ onAdd }) {
  const [name, setName] = useState("");
  const [price, setPrice] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const priceNum = parseFloat(price);
    if (!name.trim() || isNaN(priceNum) || priceNum <= 0) return;
    setSubmitting(true);
    try {
      await onAdd({ name: name.trim(), price: priceNum });
      setName("");
      setPrice("");
    } finally {
      setSubmitting(false);
    }
  };

  const canSubmit =
    name.trim().length > 0 && parseFloat(price) > 0 && !submitting;

  return (
    <div
      data-testid="add-goal-form-card"
      className="chunky-card p-5 sm:p-6 mt-5"
      style={{ backgroundColor: "#FFF3C2" }}
    >
      <h2 className="font-display text-2xl sm:text-3xl text-navy mb-1">
        WANT SOMETHING?
      </h2>
      <p className="font-display text-base text-navy/70 mb-4">
        Add it as a goal and see how close you are!
      </p>

      <form onSubmit={handleSubmit} className="space-y-3">
        <input
          data-testid="goal-name-input"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="What do you want? (e.g. Lego set)"
          className="w-full font-display text-lg sm:text-xl text-navy rounded-2xl border-4 border-navy px-4 py-3 outline-none bg-white"
          style={{ boxShadow: "0 4px 0 0 #2A2D7C" }}
          maxLength={50}
        />
        <div className="flex gap-3">
          <div className="relative flex-1">
            <span className="absolute left-4 top-1/2 -translate-y-1/2 font-display text-xl sm:text-2xl text-navy pointer-events-none">
              $
            </span>
            <input
              data-testid="goal-price-input"
              type="number"
              inputMode="decimal"
              min="0"
              step="0.01"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
              placeholder="0"
              className="w-full font-display text-lg sm:text-xl text-navy rounded-2xl border-4 border-navy pl-9 pr-4 py-3 outline-none bg-white"
              style={{ boxShadow: "0 4px 0 0 #2A2D7C" }}
            />
          </div>
          <button
            data-testid="add-goal-btn"
            type="submit"
            disabled={!canSubmit}
            className="chunky-btn px-5 sm:px-6 text-xl flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
            style={{ backgroundColor: "#FF4D9D", color: "white" }}
          >
            <Plus className="w-6 h-6" strokeWidth={4} />
            ADD
          </button>
        </div>
      </form>
    </div>
  );
}
